var React = require('react');

function VtbComponent (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","fillOpacity":"0","d":"M0 0h40v40H0z"}))),React.createElement("path",{"fill":"none","d":"M0 0h40v40H0z","key":1}),React.createElement("g",{"clipPath":"url(#a)","key":2},[React.createElement("path",{"fill":"#0D2C90","fillRule":"evenodd","d":"M40 20a20 20 0 1 1-40.01-.01A20 20 0 0 1 40 20Z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M30.65 16.5H12.03l1.34-3.5H32l-1.35 3.5Zm-.67 1.75H11.35l-1.34 3.5h18.62l1.35-3.5Zm-2.01 5.24H9.34L8 27h18.6l1.37-3.51Z","key":1})])]);
}

VtbComponent.defaultProps = {"width":"40","height":"40","fill":"none"};

module.exports = VtbComponent;

VtbComponent.default = VtbComponent;
